import { Box, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import SectionHeader from '../SectionHeader'
import Sparkline from '../Sparkline'
import { ATTENTION_AVG, ATTENTION_CURVE } from './resultsMockData'

/** Average attention KPI + sparkline of the engagement curve over the clip. */
export default function AttentionCurveCard() {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('results')

  return (
    <Box sx={{ bgcolor: c.white, border: `1px solid ${c.ink08}`, borderRadius: '16px', p: 2.5, display: 'flex', flexDirection: 'column', gap: 1.75 }}>
      <SectionHeader title={t('attention.title')} subtitle={t('attention.sub')} />
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 30, color: c.ink, fontVariantNumeric: 'tabular-nums' }}>
          {ATTENTION_AVG}
          <Box component="span" sx={{ fontSize: 18, color: c.ink56 }}>%</Box>
        </Typography>
        <Typography sx={{ fontSize: 12, color: c.success, fontWeight: 600 }}>{t('attention.delta')}</Typography>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Sparkline points={ATTENTION_CURVE} color={theme.affexy.emotion.attention} height={64} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: 10.5, color: c.ink48 }}>
        <span>0:00</span>
        <span>0:30</span>
      </Box>
    </Box>
  )
}
